import React from "react";

const NotFound = () => {
  return (
    <div>
      <strong>The page you are looking for does not exist!</strong>
    </div>
  );
};

export default NotFound;
